export const SYSTEM_PROMPTS = {
  primariaMedia: '[PROFILE:primariaMedia]',
  primariaAlta: '[PROFILE:primariaAlta]',
  preparatoria: '[PROFILE:preparatoria]',
};
